// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"Subcategories_wrapperComponent__P-h2g","subcategory":"Subcategories_subcategory__kSe2R","name":"Subcategories_name__iwsyv"};